<template>
  <nav
    class="navbar"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <slot name="brand" />
      <div class="navbar-item">
        <a
          role="button"
          @click="toggleActive"
          class="navbar-burger burger"
          :class="{ 'is-active': isActive }"
          aria-label="menu"
          aria-expanded="false"
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>
    </div>
    <div
      class="navbar-menu"
      :class="{ 'is-active': isActive }"
    >
      <div class="navbar-end">
        <slot
          name="links"
          :close="closeMenu"
        />
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data: function () {
    return {
      isActive: false
    }
  },
  methods: {
    toggleActive () {
      this.isActive = !this.isActive
    },
    closeMenu () {
      this.isActive = false
    }
  }
}
</script>

<style scoped>
.navbar-brand {
  flex-grow: 1;
}

.navbar-menu {
  flex-grow: 0;
}

.navbar-item {
  padding-top: 0px;
  padding-bottom: 0px;
}

.navbar-burger.burger span {
  width: 25px;
  height: 3px;
}
</style>
